<app-modal
	[title]="'SUCCESS'|translate"
	#flightBookingdeliveryModal2
	[showModal]="showFlightBookingDeliveryModal"
	modalWidth="40"
	(closeModalFrom2NDParent)="showFlightBookingDeliveryModal = false">
	<div *ngIf="showFlightBookingDeliveryModal" class="text-center p-4">
        <p>{{ "FLIGHT_MODIFICATION_REQUEST_SENT_SUCCESSFULLY" | translate }}</p>
        <div class="text-center">
            <button
                class="btn btn-primary px-4 py-2"
                style="width: 100px;"
                (click)="goBack()"
            >
                {{ "BACK" | translate }}
            </button>
        </div>
    </div>
</app-modal>

<section [ngClass]="{ 'arabic-css': isArabic() }">
    <div class="row page-title">
        <div class="container clear-padding text-center flight-title">
            <h3>{{ "EDIT_FLIGHT_RESERVATION" | translate }}</h3>
        </div>
    </div>

    <div class="container edit-reservation-form mt-4" style="min-height: 700px;">
        <form #editForm="ngForm" (ngSubmit)="onSubmit(editForm)">
            <div class="form-group mb-3">
                <label for="changeType">{{ "WHAT_DO_YOU_WANT_TO_CHANGE" | translate }}</label>
                <select
                    id="changeType"
                    name="changeType"
                    class="form-control"
					style="height: 40px;"
                    required
                    [(ngModel)]="formData.changeType"
                >
                    <option value="" disabled selected>
                        {{ "CHOOSE_AN_OPTION" | translate }}
                    </option>
                    <option *ngFor="let item of typeList" [value]="item.value">
                        {{ item.label | translate }}
                    </option>
                </select>
            </div>

            <!-- Textarea -->
            <div class="form-group mb-3">
                <label for="details"
                    >{{ "PLEASE_SPECIFY_WHAT_YOU_WANT_TO_CHANGE" | translate }}</label
                >
                <textarea
                    id="details"
                    name="details"
                    class="form-control"
					style="padding: 10px;"
                    minlength="3"
                    rows="4"
                    required
                    [(ngModel)]="formData.details"
                    style="min-height: 300px;"
                    placeholder="Exemple : Je voudrais annuler ma réservation"
                    placeholder="{{ 'EXAMPLE_I_WOULD_LIKE_TO_CANCEL_MY_RESERVATION' | translate }}"
                ></textarea>
            </div>

            <div class="text-center">
                <button
                    type="submit"
                    class="btn btn-primary px-4 py-2 w-100"
                    [disabled]="!editForm.valid || isSubmitting"
                >
                    {{ "SEND_REQUEST" | translate }}
                </button>
            </div>
        </form>
    </div>
</section>
